// extracted by mini-css-extract-plugin
export default {"container":"PostComment_container__6PhJZ","comment_input":"PostComment_comment_input__h5gSF","input_area":"PostComment_input_area__eu2ZJ"};